<template>
  <section style="margin: 0px !important">
    <div
      class="previewContainer"
      @click="cancelPreview($event)"
      v-if="searchingGroup"
    >
      <GroupPreview />
    </div>
    <div
      class="previewContainer"
      @click="cancelPreview($event)"
      v-if="addingMembers"
    >
      <AddGroupMembers />
    </div>
    <div
      class="previewContainer"
      @click="cancelPreview($event)"
      v-if="creatingGroup"
    >
      <CreateGroup />
    </div>
    <div class="createGroupButton" @click="createGroup">
      <img src="@/assets/createGroupIcon.svg" class="createGroupImg" />
    </div>
    <div
      class="previewContainer"
      @click="cancelPreview($event)"
      v-if="changingImage"
    >
      <ChangeImage />
    </div>

    <div
      @dragenter="showDropArea = true"
      @mouseout="showDropArea = false"
      @drop="showDropArea = false"
    >
      <div id="backBox"></div>

      <Navbar />
      <!-- 3 columns for main page -->
      <div class="mainFlex" v-if="doneLoading">
        <!-- FIRST COLUMN -->
        <div class="flexLeft">
          <Groups :key="groupKey" />
        </div>

        <!-- SECOND COLUMN -->
        <!-- start of chat container design -->
        <div class="flexMid" v-if="doneLoading || !user.allGroups.length">
          <div
            class="midFrame"
            v-if="loadedInitPosts || !user.allGroups.length"
          >
            <div v-if="!user.allGroups.length" class="headerContainer">
              <b class="groupTitle">Welcome to CourseLnk!</b>
            </div>
            <div v-else class="headerContainer">
              <b class="groupTitle">{{ this.topGroupName }}</b>
              <div class="groupButtonRow">
                <div
                  @click="addMembers"
                  class="groupInfoButton groupAddButton"
                ></div>
                <div @click="renderGroupInfo" class="groupInfoButton"></div>
              </div>
            </div>
          </div>
          <div
            v-if="!user.allGroups.length"
            class="midTop container is-fluid emptyChatsContainer"
          >
            <img class="emptyChatsIcon" src="@/assets/firstIcon.png" />
          </div>
          <div
            v-else
            @scroll="onScroll"
            class="midTop container is-fluid"
            :class="{ isWindow: isWindows }"
            style="overflow-x: hidden"
          >
            <div class="posts is-multiline" :key="componentKey">
              <div
                v-if="recentPosts.length < 24 && loadedInitPosts"
                class="topChatContainer"
              >
                <img class="topImage" :src="curGroup.profileImage" />
                <b style="font-size: 23px">{{ curGroup.name }}</b>
                <p style="color: #a0a0a0">{{ typeOfChat }}</p>
                <div
                  class="flexRow groupStartButtons"
                  v-if="groupType != 'directMessages'"
                >
                  <div class="groupStartColumn">
                    <div class="groupStartButton">
                      <img
                        @click="addMembers"
                        class="groupStartImg"
                        src="@/assets/groupStartAddFriend.svg"
                      />
                    </div>
                    Invite
                  </div>
                  <div class="groupStartColumn">
                    <!--vue-dropzone
                      class="groupStartButton groupStartButtonImg"
                      id="dropzone2"
                      ref="profileDropZone"
                      :include-styling="false"
                      :options="dropzoneOptions"
                      @vdropzone-complete="setGroupImage"
                    >
                    </vue-dropzone-->
                    <div
                      @click="setImage"
                      class="groupStartButton groupStartButtonImg"
                    ></div>
                    Set Pic
                  </div>
                </div>
                <div v-else class="textButton" @click="routeChange">
                  View Profile
                </div>
              </div>
              <div v-for="(post, index) in posts" :key="index">
                <!-- this is the post card -->
                <p v-if="shouldDisplayDate(index)" class="time">
                  {{ date(post.created_at) }}
                </p>

                <Post
                  :post="post"
                  :recentPosts="recentPosts"
                  :index="index"
                  :replies="replies"
                  :listReplies="listReplies"
                  @toggleClip="toggleClip"
                  @onDelete="onDelete"
                  @reply="reply"
                  @openGallery="openGallery"
                  @viewReplies="viewReplies"
                />
                <div></div>
              </div>
            </div>
            <div v-if="hasSeenLastPost" class="readReceiptContainer">
              <template v-if="delayed">
                <img class="readReceipt" src="@/assets/Icons/SentIcon.png" />
              </template>
              <template v-else>
                <img
                  v-if="checkLastSeen"
                  class="readReceipt"
                  src="@/assets/Icons/DeliveredIcon.svg"
                />
                <div
                  v-else
                  v-for="(userBubble, index) in hasSeenLastPost"
                  :key="index"
                >
                  <div v-if="checkUser(userBubble.id, index)">
                    <img class="readReceipt" :src="userBubble.profileImage" />
                  </div>
                </div>
              </template>
            </div>
          </div>

          <div class="midBottom">
            <div class="extraBox">
              <div class="flex-file">
                <!-- uploading files -->
                <vue-dropzone
                  v-if="showDropArea || fileDropped"
                  ref="imgDropZone"
                  id="dropzone"
                  :options="dropzoneOptions"
                  @vdropzone-removed-file="onFileRemove"
                  @vdropzone-added-file="fileDropped = true"
                  @vdropzone-complete="afterComplete"
                ></vue-dropzone>

                <label for="file-upload" class="custom-file-upload">
                  <i class="fa fa-cloud-upload"></i>
                </label>
              </div>

              <!-- If the post is a reply -->
              <div
                v-if="isReply && !showDropArea && !fileDropped"
                class="flex-reply"
              >
                <div class="replyingText">
                  <p>Replying to {{ replyingTo }}</p>
                  <i>{{ replyingMessage }}</i>
                </div>
                <div class="flex-remove">
                  <button @click="isReply = false" class="remButton">X</button>
                </div>
              </div>

              <div
                class="flexRow additionalBox"
                :class="{ additionalSelected: isShowingAdditional }"
              >
                <div class="additionalButtons additionalFile">
                  <span class="additionalInfo filePosition">Attach File</span>
                  <vue-dropzone
                    ref="imgAttachDropZone"
                    class="additionalDropzone"
                    id="attachDropzone"
                    :include-styling="false"
                    :options="dropzoneOptions"
                    @vdropzone-complete="afterAttach"
                  ></vue-dropzone>
                </div>
                <div class="additionalButtons additionalCal">
                  <span class="additionalInfo">Coming Soon!</span>
                </div>
                <div class="additionalButtons additionalClip">
                  <span class="additionalInfo">Coming Soon!</span>
                </div>
                <div class="additionalButtons additionalPhoto">
                  <span class="additionalInfo photoPosition">Attach Photo</span>
                  <vue-dropzone
                    ref="imgAttachDropZone"
                    id="attachDropzone"
                    class="additionalDropzone"
                    :include-styling="false"
                    :options="dropzoneOptions"
                    @vdropzone-complete="afterAttach"
                  ></vue-dropzone>
                </div>
                <div class="additionalButtons additionalEmoji">
                  <span class="additionalInfo">Coming Soon!</span>
                </div>
              </div>
            </div>

            <!-- table -->
            <div
              class="chat-mid"
              :style="[!user.allGroups.length ? { pointerEvents: 'none' } : {}]"
            >
              <!-- post itself -->
              <form>
                <!-- Text input area -->
                <div class="textArea">
                  <div class="leftside">
                    <div
                      @click="toggleAdditional()"
                      class="textAreaTags addTag"
                      :class="{ choseAdditional: isShowingAdditional }"
                    ></div>
                    <vue-dropzone
                      ref="imgAttachDropZone"
                      id="attachDropzone"
                      class="textAreaTags docButton"
                      :include-styling="false"
                      :options="dropzoneOptions"
                      @vdropzone-complete="afterAttach"
                    ></vue-dropzone>
                    <div class="textAreaTags addEmoji"></div>
                  </div>

                  <div id="tagContainer" contenteditable="false">
                    <ul v-for="(tag, index) in tags" :key="index">
                      <li class="tagOption" @click="selectTag(tag.name)">
                        {{ tag.name }}
                      </li>
                    </ul>
                  </div>

                  <ResizeAuto style="flex-shrink: 1">
                    <template v-slot:default="{ resize }">
                      <div
                        id="message"
                        contenteditable="true"
                        @keyup="updateContent($event)"
                        @keydown.enter.exact.prevent
                        @keyup.enter.exact="onCreatePost"
                        rows="1"
                        @input="resize"
                      >
                        <p v-if="!user.allGroups.length">
                          Join courses to get started!
                        </p>
                      </div>
                    </template>
                  </ResizeAuto>

                  <!-- Add Post Button -->
                  <div class="rightside">
                    <button
                      @click.prevent="onCreatePost"
                      class="sendButton is-success bottom"
                    ></button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        <!-- THIRD COLUMN -->
        <GroupInfo />
        <div class="floatRightContainer">
          <router-link
            class="componentRoute navChat"
            @click.native="setMessageBoard"
            :class="{
              onChat: onMessageBoard,
            }"
            :to="{
              name: 'MessageBoard',
              params: {
                name: this.groupName.replace(/\s/g, '-'),
                id: this.groupId,
                type: this.groupType,
              },
            }"
          ></router-link>
          <router-link
            class="componentRoute navCalendar"
            v-if="
              user.allGroups.length > 0 &&
                (curGroup.hasCalendar || curGroup.type == 'courses')
            "
            @click.native="setCalendar"
            :class="{
              onCal: onCalendar,
            }"
            :to="{
              name: 'Calendar',
              params: {
                name: this.groupName.replace(/\s/g, '-'),
                id: this.groupId,
              },
            }"
          ></router-link>
        </div>
        <!-- BOTTOM -->

        <!-- END OF TABLE -->

        <LightBox ref="lightbox" :media="media" :show-light-box="false" />
      </div>
    </div>
  </section>
</template>

<script>
require("vue-image-lightbox/dist/vue-image-lightbox.min.css");
import { mapState, mapActions } from "vuex";
import firebase from "@/firebase";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import ResizeAuto from "@/components/ResizeAuto";
import Groups from "@/components/Groups";
import GroupInfo from "@/components/GroupInfo";
import Navbar from "@/components/Navbar";
import Post from "@/components/Post";
import moment from "moment";
import db from "@/db";
import LightBox from "vue-image-lightbox";
import router from "@/router/index";
import GroupPreview from "@/components/group/GroupPreview.vue";
import CreateGroup from "@/components/group/CreateGroup.vue";
import AddGroupMembers from "@/components/AddGroupMembers";
import ChangeImage from "@/components/ChangeImage";
//import linkPreviewGenerator from "link-preview-generator";

export default {
  props: ["name", "id", "type"],
  components: {
    vueDropzone: vue2Dropzone,
    ResizeAuto,
    LightBox,
    Groups,
    GroupInfo,
    Post,
    Navbar,
    GroupPreview,
    CreateGroup,
    AddGroupMembers,
    ChangeImage,
  },
  data: () => ({
    isShowingAdditional: false,
    isWindows: false,
    currentGroup: {},
    //dropzone
    showDropArea: false, //Whether the drop area should be shown
    fileDropped: false, //If the user dropped a file in the drop zone
    dropzoneOptions: {
      url: "https://httpbin.org/post",
      thumbnailWidth: 150,
      thumbnailHeight: 150,
      maxFilesize: 5,
      maxFiles: 9,
      duplicateCheck: true,
      addRemoveLinks: true,
    },
    //reply info
    replyingTo: "", //The name of the user you are replying to
    replyingToId: "", //The id of the user you are replying to
    replyingMessage: "", //The message of the post your are replying to
    listReplies: "", //id of post in which to list replies for
    notificationGroups: [], //The groups that are being listened to for notification
    //scroll
    scroll: true, //whether to scroll to the bottom on updated()
    lastScroll: null, //the previous scroll position

    //posts
    oldContent: "",
    oldChild: null,
    tags: [],
    taggedNames: [],
    spans: [],
    delayed: true,
    recentPosts: [],
    posts: [],
    replyPost: null,
    isReply: false,
    media: [], //Clickable images in a post
    // Post info for adding a post
    post: {
      content: "",
    },
    listeners: [], // list of listeners
    css: "",
    topGroupName: "",
    componentKey: 0,
    groupKey: 0,
    doneLoading: false,
    typeOfChat: "",
    postsLoaded: false,
    finalLoad: 0,
    hasSeenLastPost: [],
  }),

  created() {
    this.setUserGroups();
    if (
      this.id &&
      this.name &&
      this.type &&
      this.user.allGroups.findIndex((x) => x.id === this.id) !== -1
    ) {
      this.$store.commit("messageBoard/setGroupId", this.id);
      this.$store.commit(
        "messageBoard/setGroupName",
        this.name.replace("-", " ")
      );
      this.$store.commit("messageBoard/setGroupType", this.type);
    } else if (
      this.id &&
      this.name &&
      this.type &&
      this.user.allGroups.findIndex((x) => x.id === this.id) === -1
    ) {
      db.collection(this.type)
        .doc(this.id)
        .get()
        .then((doc) => {
          var previewCourse = doc.data();
          previewCourse.type = this.type;
          previewCourse.id = this.id;
          this.$store.commit("messageBoard/setGroupPreview", previewCourse);
          this.$store.commit("messageBoard/setSearchGroup", true);
        });
    } else if (this.user.allGroups.length > 0) {
      this.user.allGroups.sort((a, b) => b.timeOfLastPost - a.timeOfLastPost);
      this.$router.replace({
        name: "MessageBoard",
        params: {
          name: this.user.allGroups[0].name.replace(" ", "-"),
          id: this.user.allGroups[0].id,
          type: this.user.allGroups[0].type,
        },
      });
      this.$store.commit("messageBoard/setCurGroup", this.user.allGroups[0]);
      this.$store.commit(
        "messageBoard/setGroupType",
        this.user.allGroups[0].type
      );
      this.$store.commit("messageBoard/setGroupId", this.user.allGroups[0].id);
      this.$store.commit(
        "messageBoard/setGroupName",
        this.user.allGroups[0].name
      );
    }
    this.setMessageBoard();
    if (!this.curGroup.recentPosts) {
      this.curGroup.recentPosts = [];
    }
    this.setLastVisited(this.groupId);
    this.setInitialNotifications();
    this.topGroupName = this.groupName;
    this.doneLoading = true;
    this.setData();
    this.setTopText();
  },

  mounted() {
    this.isWindows = this.checkOS();
    this.oldChild = document.getElementById("tagContainer");
  },

  unmounted() {
    this.detachListeners();
  },

  watch: {
    //Scroll to bottom when post is added
    posts() {
      this.$nextTick(() => {
        if (this.scroll) {
          this.scrollToBottom();
        }
      });
    },

    //Set data for selected group
    async groupId() {
      this.doneLoading = false;
      this.$store.commit("messageBoard/setLoadedInit", false);
      this.checkUserGroups();
      this.checkGroupFields();
      this.detachListeners();
      this.setLastVisited(this.lastGroupId);
      this.resetProperties();
      this.setData();
      this.doneLoading = true;
      this.setTopText();
    },

    async groupName() {
      this.topGroupName = await this.groupName;
    },
    listReplies() {
      this.initReplies(this.listReplies);
    },
  },

  computed: {
    ...mapState("messageBoard", [
      "replies",
      "lastGroupId",
      "groupId",
      "groupType",
      "curGroup",
      "groupName",
      "newNotification",
      "searchingGroup",
      "groupPreview",
      "creatingGroup",
      "changingImage",
      "loadedInitPosts",
    ]),
    ...mapState("user", ["user"]),
    ...mapState("groups", ["updateAllGroups"]),
    ...mapState("groupInfo", [
      "showingInfo",
      "addingMembers",
      "defaultGroupImage",
    ]),
    ...mapState("mainPage", [
      "onMessageBoard",
      "onCalendar",
      "onReview",
      "onUpload",
    ]),
    checkLastSeen() {
      if (this.hasSeenLastPost) {
        return this.hasSeenLastPost.length < 2;
      }
      return true;
    },
  },
  methods: {
    ...mapActions("messageBoard", [
      "createPost",
      "addPosts",
      "deletePost",
      "initReplies",
      "newestNotification",
      "unbindPosts",
      "unsubscribeFromTopic",
      "subscribeToTopic",
      "setGroupId",
      "setGroupName",
    ]),
    ...mapActions("user", ["logout", "updateUserGroups"]),
    ...mapActions("groupInfo", [
      "getGroupType",
      "getGroupsFromType",
      "getGroupName",
    ]),
    setImage() {
      this.$store.commit("messageBoard/setChangeImage", true);
    },
    routeChange() {
      this.$router.replace({
        name: "PublicProfile",
        params: { userName: this.groupName.replace(" ", "-") },
      });
    },
    setMessageBoard() {
      this.$store.commit("mainPage/setMessageBoard");
    },
    toggleAdditional() {
      this.isShowingAdditional = !this.isShowingAdditional;
    },
    setCalendar() {
      this.$store.commit("mainPage/setCalendar");
    },
    checkOS() {
      if (navigator.appVersion.indexOf("Win") != -1) {
        return true;
      }
      return false;
    },
    checkUser(id, index) {
      return this.user.id !== id && index < 8;
    },

    renderGroupInfo() {
      this.$store.commit("groupInfo/setShowingInfo", !this.showingInfo);
    },

    setTopText() {
      if (this.curGroup.recentPosts) {
        if (this.curGroup.recentPosts.length < 24) {
          if (this.curGroup.type === "courses") {
            this.typeOfChat = "Course Chat";
          } else if (this.curGroup.type === "faculties") {
            this.typeOfChat = "Faculty Chat";
          } else if (this.curGroup.type == "groups") {
            this.typeOfChat = "Group Chat";
          } else {
            this.typeOfChat = "";
          }
        }
      }
    },

    updateContent(event) {
      var input = document.getElementById("message");
      if (event.keyCode === 8 || event.keyCode === 46) {
        //this.removeTag(input.innerHTML);
      }
      var html = input.innerHTML;
      //var lastIndex = 0;
      this.post.content = input.innerText;
      var nodes = input.childNodes;
      nodes.forEach((node) => {
        if (node.nodeName == "#text") {
          let text = node.textContent;
          if (text.includes("@")) {
            if (!html.includes("tagContainer")) {
              input.insertBefore(this.oldChild, node.lastChild);
            }
            let index = text.indexOf("@");
            let name = text.split("\n")[0].substring(index + 1);
            this.addUserTags(name);
          } else {
            this.tags = [];
          }
        }
      });
      /*
      if (this.post.atRanges) {
        if (this.post.atRanges.length > 0) {
          lastIndex = this.post.atRanges[this.post.atRanges.length - 1];
        }
      }
      if (text.includes("@", lastIndex)) {
        if (!html.includes("tagContainer")) {
          input.appendChild(this.oldChild);
        }
        let index = text.lastIndexOf("@");
        let name = text.split("\n")[0].substring(index + 1);
        this.addUserTags(name);
      } else {
        this.tags = [];
      }
      */
    },
    addUserTags(name) {
      this.tags = [];
      var text = document.getElementById("message").innerText;
      this.curGroup.users.forEach((user) => {
        const words = user.name.split(" ");
        words.forEach((word) => {
          if (word.toLowerCase().startsWith(name.toLowerCase())) {
            if (
              !this.tags.includes(user) &&
              this.user.id !== user.user_id &&
              !text.includes(user.name)
            ) {
              this.tags.push(user);
            }
          }
        });
      });
    },
    selectTag(name) {
      var input = document.getElementById("message");
      var html = input.innerHTML;
      var text = input.innerText;
      var index = text.lastIndexOf("@");
      /*
      if (!this.post.atRanges) {
        this.post.atRanges = [];
      }
      this.post.atRanges.push(index);
      this.post.atRanges.push(index + name.length + 1);
      */
      if (!this.taggedNames.includes(name)) {
        this.taggedNames.push(name);
      }
      let htmlIndex = html.lastIndexOf("@");
      let firstHalf = html.substring(0, htmlIndex);
      input.innerHTML = firstHalf;
      var span = document.createElement("span");
      span.style.color = "blue";
      span.style.fontWeight = "bold";
      span.contentEditable = "false";
      span.innerHTML = "@" + name;
      span.id = this.taggedNames.length;
      this.spans.push(index + name.length + 1);
      input.appendChild(span);
      input.innerHTML += " ";
      this.tags = [];
    },
    addMembers() {
      this.$store.commit("groupInfo/setAddingMembers", true);
    },
    createGroup() {
      this.$store.commit("messageBoard/setCreateGroup", true);
    },
    removeTag(input) {
      const filterBy = (list, str) =>
        list.filter((item) =>
          new RegExp("^" + str.replace(/\*/g, ".*") + "$").test(item)
        );
      if (input !== "") {
        var oldItems = input.split(" ");
        var oldIDs = filterBy(oldItems, "id=*");
        oldIDs.forEach(
          (id, index) => (oldIDs[index] = Number(id.match(/\d+/)))
        );
        this.spans.forEach((id, index) => {
          if (oldIDs[index] !== id) {
            let newIndex = this.post.atRanges.indexOf(id);
            this.post.atRanges.splice(newIndex, 1);
            this.post.atRanges.splice(newIndex - 1, 1);
            this.spans.splice(index, 1);
          }
        });
      } else {
        this.post.atRanges = [];
      }
    },
    async toggleClip(post) {
      var alreadyClipped = false;
      if (post.user_id === this.user.id) {
        return;
      }
      db.collection("users")
        .doc(this.user.id)
        .get()
        .then((doc) => {
          for (const clip in doc.data().clips) {
            if (doc.data().clips[clip] === post.id) {
              alreadyClipped = true;
            }
          }
          let index = this.recentPosts.findIndex(
            (recentPost) => recentPost.id === post.id
          );
          if (!alreadyClipped) {
            db.collection("posts")
              .doc(post.id)
              .update({
                clips: firebase.firestore.FieldValue.increment(1),
              });
            db.collection("users")
              .doc(this.user.id)
              .update({
                clips: firebase.firestore.FieldValue.arrayUnion(post.id),
              });
            if (index !== -1) {
              if (!this.recentPosts[index].clips) {
                this.recentPosts[index].clips = 0;
              }
              this.recentPosts[index].clips = this.recentPosts[index].clips + 1;
              db.collection(this.groupType)
                .doc(this.groupId)
                .update({
                  recentPosts: this.recentPosts,
                });
            }
          } else {
            db.collection("posts")
              .doc(post.id)
              .update({
                clips: firebase.firestore.FieldValue.increment(-1),
              });
            db.collection("users")
              .doc(this.user.id)
              .update({
                clips: firebase.firestore.FieldValue.arrayRemove(post.id),
              });
            if (index !== -1) {
              this.recentPosts[index].clips = this.recentPosts[index].clips - 1;
              db.collection(this.groupType)
                .doc(this.groupId)
                .update({
                  recentPosts: this.recentPosts,
                });
            }
          }
        });
    },
    cancelPreview(event) {
      if (event.target.className == "previewContainer") {
        this.$store.commit("messageBoard/setSearchGroup", false);
        this.$store.commit("messageBoard/setCreateGroup", false);
        this.$store.commit("messageBoard/setChangeImage", false);
        this.$store.commit("groupInfo/setAddingMembers", false);
        this.$store.commit("profile/setInterests", []);
      }
    },
    getNotificationContent() {
      let notification = this.newNotification[0];
      if (notification.content == "") {
        let attach =
          notification.files.length == 1 ? "Attachment" : "Attachments";
        return notification.files.length + " " + attach;
      } else {
        return notification.content;
      }
    },
    ...mapActions("groups", ["setGroupNotificationInfo", "getTimeSincePost"]),
    isUnread(group) {
      return group.lastVisited < this.newNotification[0].created_at;
    },
    checkGroupFields() {
      this.user.courses.forEach((course, userIndex) => {
        if (!course.recentPosts) {
          db.collection("courses")
            .doc(course.id)
            .get()
            .then((doc) => {
              course.hasSeenLastPost = doc.data().hasSeenLastPost;
              course.recentPosts = doc.data().recentPosts
                ? doc.data().recentPosts
                : this.defaultGroupImage;
              course.school_id = doc.data().school_id;
              course.users = doc.data().users;
              course.profileImage = doc.data().profileImage
                ? doc.data().profileImage
                : this.defaultGroupImage;
              course.type = "courses";
              this.setGroupNotificationInfo({
                group: course,
                notification: doc.data().recentPosts[
                  doc.data().recentPosts.length - 1
                ],
              });
              this.user.courses[userIndex] = course;
              this.$store.commit("user/setUser", this.user);
            });
        }
      });

      this.user.groups.forEach((group, userIndex) => {
        if (!group.recentPosts) {
          db.collection("groups")
            .doc(group.id)
            .get()
            .then((doc) => {
              if (!doc.data()) {
                console.log(group);
              }
              group.hasSeenLastPost = doc.data().hasSeenLastPost;
              if (doc.data().recentPosts) {
                group.recentPosts = doc.data().recentPosts;
              } else {
                group.recentPosts = [];
              }
              group.school_id = doc.data().school_id;
              group.users = doc.data().users;
              group.profileImage = doc.data().profileImage
                ? doc.data().profileImage
                : this.defaultGroupImage;
              group.type = "groups";
              this.setGroupNotificationInfo({
                group: group,
                notification: doc.data().recentPosts[
                  doc.data().recentPosts.length - 1
                ],
              });
              if (doc.data().requests) {
                group.requests = doc.data().requests;
              }
              this.user.groups[userIndex] = group;
              this.$store.commit("user/setUser", this.user);
            });
        }
      });

      this.user.faculties.forEach((faculty, userIndex) => {
        if (!faculty.recentPosts) {
          db.collection("faculties")
            .doc(faculty.id)
            .get()
            .then((doc) => {
              faculty.hasSeenLastPost = doc.data().hasSeenLastPost;
              faculty.name = doc.data().name;
              if (doc.data().recentPosts) {
                faculty.recentPosts = doc.data().recentPosts;
              } else {
                faculty.recentPosts = [];
              }
              faculty.school_id = doc.data().school_id;
              faculty.type = "faculties";
              faculty.profileImage = doc.data().profileImage
                ? doc.data().profileImage
                : this.defaultGroupImage;
              this.setGroupNotificationInfo({
                group: faculty,
                notification: doc.data().recentPosts[
                  doc.data().recentPosts.length - 1
                ],
              });
              this.user.faculties[userIndex] = faculty;
              this.$store.commit("user/setUser", this.user);
            });
        }
      });

      this.user.directMessages.forEach((dm, userIndex) => {
        if (!dm.recentPosts) {
          db.collection("directMessages")
            .doc(dm.id)
            .get()
            .then((doc) => {
              var otherUser = doc
                .data()
                .users.find((otherUser) => otherUser.user_id !== this.user.id);
              dm.hasSeenLastPost = doc.data().hasSeenLastPost;
              dm.name = otherUser.name;
              dm.profileImage = otherUser.profileImage;
              if (doc.data().recentPosts) {
                dm.recentPosts = doc.data().recentPosts;
              } else {
                dm.recentPosts = [];
              }
              dm.token = otherUser.token;
              dm.type = "directMessages";
              this.setGroupNotificationInfo({
                group: dm,
                notification: doc.data().recentPosts[
                  doc.data().recentPosts.length - 1
                ],
              });
              this.user.directMessages[userIndex] = dm;
              this.$store.commit("user/setUser", this.user);
            });
        }
      });
    },
    checkUserGroups() {
      db.collection("users")
        .doc(this.user.id)
        .get()
        .then((doc) => {
          var user = doc.data();
          if (user.courses.length !== this.user.courses.length) {
            user.courses.forEach((course) => {
              let index = this.user.courses.findIndex(
                (x) => x.id === course.id
              );
              if (index === -1) {
                this.user.courses.push(course);
                this.$store.commit("user/setUser", this.user);
              }
            });
            this.user.courses.forEach((course, userIndex) => {
              let index = user.courses.findIndex((x) => x.id === course.id);
              if (index === -1) {
                this.user.courses.splice(userIndex, 1);
                this.$store.commit("user/setUser", this.user);
              }
            });
          }

          if (user.groups.length !== this.user.groups.length) {
            user.groups.forEach((group) => {
              let index = this.user.groups.findIndex((x) => x.id === group.id);
              if (index === -1) {
                this.user.groups.push(group);
                this.$store.commit("user/setUser", this.user);
              }
            });
            this.user.groups.forEach((group, userIndex) => {
              let index = user.groups.findIndex((x) => x.id === group.id);
              if (index === -1) {
                this.user.groups.splice(userIndex, 1);
                this.$store.commit("user/setUser", this.user);
              }
            });
          }

          if (user.faculties.length !== this.user.faculties.length) {
            user.faculties.forEach((faculty) => {
              let index = this.user.faculties.findIndex(
                (x) => x.id === faculty.id
              );
              if (index === -1) {
                this.user.faculties.push(faculty);
                this.$store.commit("user/setUser", this.user);
              }
            });
            this.user.faculties.forEach((faculty, userIndex) => {
              let index = user.faculties.findIndex((x) => x.id === faculty.id);
              if (index === -1) {
                this.user.faculties.splice(userIndex, 1);
                this.$store.commit("user/setUser", this.user);
              }
            });
          }

          if (user.directMessages.length !== this.user.directMessages.length) {
            user.directMessages.forEach((dm) => {
              let index = this.user.directMessages.findIndex(
                (x) => x.id === dm.id
              );
              if (index === -1) {
                this.user.directMessages.push(dm);
                this.$store.commit("user/setUser", this.user);
              }
            });
            this.user.directMessages.forEach((dm, userIndex) => {
              let index = user.directMessages.findIndex((x) => x.id === dm.id);
              if (index === -1) {
                this.user.directMessages.splice(userIndex, 1);
                this.$store.commit("user/setUser", this.user);
              }
            });
          }
          this.updateUserGroups();
        });
    },
    async setUserGroups() {
      await db
        .collection("users")
        .doc(this.user.id)
        .get()
        .then(async (doc) => {
          var user = doc.data();
          user.id = doc.id;
          Promise.all(
            user.courses.map((course, index) => {
              db.collection("courses")
                .doc(course.id)
                .get()
                .then((doc) => {
                  user.courses[
                    index
                  ].hasSeenLastPost = doc.data().hasSeenLastPost;
                  user.courses[index].recentPosts = doc.data().recentPosts
                    ? doc.data().recentPosts
                    : this.defaultGroupImage;
                  user.courses[index].school_id = doc.data().school_id;
                  user.courses[index].users = doc.data().users;
                  user.courses[index].profileImage = doc.data().profileImage
                    ? doc.data().profileImage
                    : this.defaultGroupImage;
                  user.courses[index].type = "courses";
                  this.setGroupNotificationInfo({
                    group: user.courses[index],
                    notification: doc.data().recentPosts[
                      doc.data().recentPosts.length - 1
                    ],
                  });
                  this.$store.commit("user/setUser", user);
                });
            })
          );

          Promise.all(
            user.directMessages.map((dm, index) => {
              db.collection("directMessages")
                .doc(dm.id)
                .get()
                .then(async (doc) => {
                  var otherUser = doc
                    .data()
                    .users.find((otherUser) => otherUser.user_id !== user.id);
                  user.directMessages[
                    index
                  ].hasSeenLastPost = doc.data().hasSeenLastPost;
                  user.directMessages[index].name = otherUser.name;
                  user.directMessages[index].profileImage =
                    otherUser.profileImage;
                  if (doc.data().recentPosts) {
                    user.directMessages[
                      index
                    ].recentPosts = doc.data().recentPosts;
                  } else {
                    user.directMessages[index].recentPosts = [];
                  }
                  await db
                    .collection("users")
                    .doc(otherUser.user_id)
                    .get()
                    .then((userDoc) => {
                      user.directMessages[index].token = userDoc.data().iOSToken
                        ? userDoc.data().iOSToken
                        : "";
                    });
                  user.directMessages[index].type = "directMessages";
                  this.setGroupNotificationInfo({
                    group: user.directMessages[index],
                    notification: doc.data().recentPosts[
                      doc.data().recentPosts.length - 1
                    ],
                  });
                  this.$store.commit("user/setUser", user);
                });
            })
          );
          Promise.all(
            user.groups.map((group, index) => {
              db.collection("groups")
                .doc(group.id)
                .get()
                .then((doc) => {
                  user.groups[
                    index
                  ].hasSeenLastPost = doc.data().hasSeenLastPost;
                  user.groups[index].name = doc.data().name;
                  if (doc.data().recentPosts) {
                    user.groups[index].recentPosts = doc.data().recentPosts;
                  } else {
                    user.groups[index].recentPosts = [];
                  }
                  user.groups[index].school_id = doc.data().school_id;
                  user.groups[index].users = doc.data().users;
                  user.groups[index].profileImage = doc.data().profileImage
                    ? doc.data().profileImage
                    : this.defaultGroupImage;
                  user.groups[index].type = "groups";
                  this.setGroupNotificationInfo({
                    group: user.groups[index],
                    notification: doc.data().recentPosts[
                      doc.data().recentPosts.length - 1
                    ],
                  });
                  if (doc.data().requests) {
                    user.groups[index].requests = doc.data().requests;
                  }
                  this.$store.commit("user/setUser", user);
                });
            })
          );
          Promise.all(
            user.faculties.map((faculty, index) => {
              db.collection("faculties")
                .doc(faculty.id)
                .get()
                .then((doc) => {
                  user.faculties[
                    index
                  ].hasSeenLastPost = doc.data().hasSeenLastPost;
                  user.faculties[index].name = doc.data().name;
                  if (doc.data().recentPosts) {
                    user.faculties[index].recentPosts = doc.data().recentPosts;
                  } else {
                    user.faculties[index].recentPosts = [];
                  }
                  user.faculties[index].school_id = doc.data().school_id;
                  user.faculties[index].type = "faculties";
                  user.faculties[index].profileImage = doc.data().profileImage
                    ? doc.data().profileImage
                    : this.defaultGroupImage;
                  this.setGroupNotificationInfo({
                    group: user.faculties[index],
                    notification: doc.data().recentPosts[
                      doc.data().recentPosts.length - 1
                    ],
                  });
                  this.$store.commit("user/setUser", user);
                });
            })
          );
          //await this.$store.commit("user/setUser", this.user);
          //this.setInitialNotifications();
        });
    },
    async addToNotifGroups(group) {
      const groupName = await this.getGroupName(group);
      const currentGroupName = await this.groupName;
      if (!group.hasUnreadPosts && groupName != currentGroupName) {
        this.notificationGroups.push(group);
      }
    },

    async getTopGroupName() {
      return await this.groupName;
    },

    updateNotificationGroups(group) {
      var notifGroups = this.notificationGroups;
      const index = notifGroups.indexOf(group);
      if (index > -1) {
        this.notifGroups.splice(index, 1);
      }
      if (notifGroups.length == 0) {
        this.unbindPosts();
      } else {
        this.newestNotification(notifGroups);
      }
    },
    updateDocumentTitle() {
      if (document.ishidden) {
        document.title = "(1) CourseLnk";
      }
    },
    async updateGroupIfNotified(group) {
      let groupId = group.id;
      if (groupId === this.newNotification[0].chat_id) {
        this.setGroupNotificationInfo({
          group: group,
          notification: this.newNotification[0],
        });
        if (this.isUnread(group)) {
          this.updateNotificationGroups(group);
          this.updateDocumentTitle();
        }
      }
    },
    setData() {
      this.$store.commit("groupInfo/setShowingInfo", false);
      this.delayed = true;
      setTimeout(() => (this.delayed = false), 500);
      this.checkForUser();
      this.initFirstPosts();
      this.scrollToBottom();
    },
    resetProperties() {
      document.getElementById("message").innerText = "";
      this.taggedNames = [];
      this.scroll = true;
      this.lastScroll = null;
      this.posts = [];
      this.groupMembers = [];
      this.replyingTo = ""; //The name of the user you are replying to
      this.replyingToId = ""; //The id of the user you are replying to
      this.replyingMessage = "";
      this.replyPost = null;
      this.resetPost();
    },
    shouldDisplayDate(index) {
      if (index == 0) {
        return true;
      }
      return (
        this.posts[index].created_at - 3600000 >
        this.posts[index - 1].created_at
      );
    },
    async initFirstPosts() {
      let listener = db
        .collection(this.groupType)
        .doc(this.groupId)
        .onSnapshot(async (doc) => {
          var userInfo = {
            name: this.user.firstName + " " + this.user.lastName,
            id: this.user.id,
            profileImage: this.user.profileImage,
          };
          db.collection(this.curGroup.type)
            .doc(this.curGroup.id)
            .update({
              hasSeenLastPost: firebase.firestore.FieldValue.arrayUnion(
                userInfo
              ),
            });
          this.posts = doc.data().recentPosts ? doc.data().recentPosts : [];
          var profileImage = doc.data().profileImage
            ? doc.data().profileImage
            : this.defaultGroupImage;
          this.recentPosts = doc.data().recentPosts
            ? doc.data().recentPosts
            : [];
          this.setGroupNotificationInfo({
            group: this.curGroup,
            notification: this.recentPosts[this.recentPosts.length - 1],
          });
          this.hasSeenLastPost = doc.data().hasSeenLastPost;
          this.curGroup.hasSeenLastPost = [];
          var curGroup = doc.data();
          curGroup.id = doc.id;
          curGroup.type = this.groupType;
          if (this.groupType == "directMessages") {
            var otherUser = doc
              .data()
              .users.find((user) => user.user_id !== this.user.id);
            this.posts.map(
              (post) => (post.profileImage = otherUser.profileImage)
            );
            profileImage = otherUser.profileImage;
            this.configurePosts(this.posts);
            await db
              .collection("users")
              .doc(otherUser.user_id)
              .get()
              .then((userDoc) => {
                curGroup.token = userDoc.data().iOSToken
                  ? userDoc.data().iOSToken
                  : "";
                let notifIndex = userDoc
                  .data()
                  .directMessages.findIndex((x) => x.id === doc.id);
                curGroup.notificationsEnabled = userDoc.data().directMessages[
                  notifIndex
                ].notificationsEnabled;
              });
          } else {
            this.configurePosts(this.posts);
          }
          curGroup.profileImage = profileImage;
          this.$store.commit("messageBoard/setCurGroup", curGroup);
        });
      await this.listeners.push(listener);
    },
    updatePost(post, newPost) {
      if (newPost.deleted) {
        post.deleted = true;
      }
      post.clips = newPost.clips;
      post.replies = newPost.replies;
      post.content = newPost.content;
      this.configurePosts(this.posts);
    },

    configureLastPost() {
      let posts = this.posts;
      if (posts.length < 2) {
        return;
      }
      let lastPost = posts[posts.length - 1];
      let secondLastPost = posts[posts.length - 2];

      lastPost.isLastPostInARowFromUser = true;
      if (
        secondLastPost.clips > 0 ||
        lastPost.created_at - secondLastPost.created_at > 3600000
      ) {
        lastPost.isFirstPostInARowFromUser = true;
      } else if (lastPost.user_id == secondLastPost.user_id) {
        secondLastPost.isLastPostInARowFromUser = false;
        secondLastPost.profileImage = "";
        lastPost.sameIdAsPreviousPost = true;
        lastPost.isFirstPostInARowFromUser = false;
      } else {
        lastPost.isFirstPostInARowFromUser = true;
      }
    },
    configurePosts(posts) {
      if (posts.length > 0) {
        var lastPostUserId = posts[0].user_id;
        posts[0].isFirstPostInARowFromUser = true;
        if (this.groupType == "directMessages") {
          posts[0].profileImage = this.curGroup.profileImage;
        }
        for (var i = 1; i < posts.length; i++) {
          if (this.groupType == "directMessages") {
            posts[i].profileImage = this.curGroup.profileImage;
          }
          if (posts[i].user_id === lastPostUserId) {
            posts[i].isFirstPostInARowFromUser =
              posts[i - 1].clips > 0 ? true : false;
            if (posts[i - 1].clips == 0) {
              posts[i - 1].isLastPostInARowFromUser = false;
            }
          } else {
            posts[i - 1].isLastPostInARowFromUser = true;
            posts[i].isFirstPostInARowFromUser = true;
          }
          if (posts[i].clips > 0) {
            posts[i].isLastPostInARowFromUser = true;
          }
          if (posts[i].created_at - posts[i - 1].created_at > 3600000) {
            posts[i - 1].isLastPostInARowFromUser = true;
            posts[i].isFirstPostInARowFromUser = true;
          }
          lastPostUserId = posts[i].user_id;
          if (i == posts.length - 1) {
            posts[i].isLastPostInARowFromUser = true;
          }
        }
      }
    },
    setupLinks() {
      this.posts.forEach((post, index) => {
        var content = post.content.split(" ");
        content.forEach(async (word) => {
          const original = word;
          if (
            (word.includes(".ca") || word.includes(".com")) &&
            !word.includes("https://")
          ) {
            word = "https://" + word;
          }
          if (this.validURL(word)) {
            this.posts[index].content.replace(original, word);
            //this.posts[index].linkPreview = await linkPreviewGenerator(word);
          }
        });
      });
    },

    validURL(str) {
      var pattern = new RegExp(
        "^(https?:\\/\\/)?" + // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
          "(\\#[-a-z\\d_]*)?$",
        "i"
      ); // fragment locator
      return !!pattern.test(str);
    },
    getMorePosts(scrollHeight) {
      var container = this.$el.querySelector(".midTop");
      let ref = db
        .collection("posts")
        .where("chat_id", "==", this.groupId)
        .where("created_at", "<", this.posts[0].created_at);
      let listener = ref
        .orderBy("created_at", "desc")
        .limit(20)
        .onSnapshot((posts) => {
          posts.docChanges().forEach((post) => {
            if (post.type === "added") {
              this.posts.unshift(post.doc.data());
            }
            if (post.type === "modified") {
              for (const index in this.posts) {
                if (post.doc.data().id === this.posts[index].id) {
                  this.updatePost(this.posts[index], post.doc.data());
                }
              }
            }
            if (post.type === "removed") {
              let index = this.posts.findIndex(
                (x) => x.id === post.doc.data().id
              );
              this.posts.splice(index, 1);
            }
          });
          this.configurePosts(this.posts);
          this.$nextTick(() => {
            container.scrollTop = container.scrollHeight - scrollHeight;
          });
        });
      this.listeners.push(listener);
    },
    removeDuplicates(myArr, newArr) {
      for (let h = 0; h < myArr.length; h++) {
        var curItem = myArr[h].doc.data().id;
        var foundCount = 0;
        // search array for item
        for (let i = 0; i < myArr.length; i++) {
          if (myArr[i].doc.data().id == myArr[h].doc.data().id) foundCount++;
        }
        if (foundCount > 1) {
          // remove repeated item from new array
          for (let j = 0; j < newArr.length; j++) {
            if (newArr[j].doc.data().id == curItem) {
              newArr.splice(j, 1);
              j--;
            }
          }
        }
      }
    },
    setPostContent(group, post) {
      if (post.content == "") {
        let attach = post.files.length == 1 ? "Attachment" : "Attachments";
        group.recentContent = post.files.length + " " + attach;
      } else {
        group.recentContent = post.content;
      }
    },
    async getRecentPost(group) {
      if (group.id) {
        db.collection("posts")
          .where("chat_id", "==", group.id)
          .orderBy("created_at", "desc")
          .limit(1)
          .get()
          .then((snapshot) => {
            snapshot.forEach((doc) => {
              this.setGroupNotificationInfo({
                group: group,
                notification: doc.data(),
              });
            });
          });
      }
    },
    async setInitialNotifications() {
      this.user.courses.forEach((course) => this.getRecentPost(course));
      this.user.faculties.forEach((faculty) => this.getRecentPost(faculty));
      this.user.groups.forEach((group) => this.getRecentPost(group));
      this.user.directMessages.forEach((dm) => this.getRecentPost(dm));
      await this.$store.commit("user/setUser", this.user);
    },
    handleVisibilityChange() {
      if (!document.hidden) {
        document.title = "CourseLnk";
      }
    },
    isImage(file) {
      return file.src.includes("png");
    },
    isVideo(file) {
      return file.src.includes("MP4") || file.src.includes("mp4");
    },
    async setLastVisited(group_id) {
      var info = {
        groupId: group_id,
        user: this.user,
      };
      var groups = await this.getGroupsFromType(info);
      for (const index in groups) {
        if (groups[index].id === group_id) {
          groups[index].lastVisited = Date.now();
          groups[index].hasUnreadPosts = false;
        }
      }
      this.$store.commit("user/setUser", this.user);
    },
    scrollToBottom() {
      if (this.$el) {
        var container = this.$el.querySelector(".midTop");
        container.scrollTop = container.scrollHeight;
      }
    },
    onScroll({ target: { scrollTop, scrollHeight, offsetHeight } }) {
      if (this.lastScrollHeight < scrollHeight && this.scroll) {
        this.scrollToBottom();
      }
      //the scrolled more than 200 from bottom set scroll to false else true
      if (scrollHeight - offsetHeight - 200 > scrollTop) {
        this.scroll = false;
      } else {
        this.scroll = true;
      }
      if (scrollTop == 0 && this.lastScroll) {
        this.getMorePosts(scrollHeight);
        this.componentKey += 1;
      }
      this.lastScrollHeight = scrollHeight;
      this.lastScroll = scrollTop;
    },
    //When a file is removed from dropzone
    onFileRemove(file) {
      for (const index in this.post.files) {
        if (this.post.files[index].name == file.name) {
          this.post.files.splice(index, 1);
        }
      }
      if (this.post.files.length == 0) {
        this.fileDropped = false;
        this.showDropArea = false;
      }
    },

    // Adds reply to a post
    async addReply(id) {
      db.collection("posts")
        .doc(id)
        .update({
          replies: firebase.firestore.FieldValue.increment(1),
        });
    },
    //Adds the files to post.files and to firebase storage if the file was drag and dropped
    async afterComplete(file) {
      this.fileDropped = true;
      try {
        const storageRef = firebase.storage().ref();
        var fileRef = "";
        // If is an image
        if (file["type"] === "image/jpeg" || file["type"] === "image/png") {
          fileRef = storageRef.child(`images/${file.name}${Date.now()}.png`);
        } else {
          fileRef = storageRef.child(`files/${file.name}`);
        }
        await fileRef.put(file);
        const downloadURL = await fileRef.getDownloadURL();
        console.log(downloadURL);
        console.log(file.name);
        this.post.files = this.post.files ? this.post.files : [];
        this.post.files.push({
          src: downloadURL,
          name: file.name,
        });
        console.log(this.post);
      } catch (error) {
        console.log(error);
      }
    },
    async afterAttach(file) {
      this.$refs.imgAttachDropZone.removeAllFiles(true);
      this.fileDropped = true;
      try {
        const storageRef = firebase.storage().ref();
        var fileRef = "";
        //If the file is an image
        if (file["type"] === "image/jpeg" || file["type"] === "image/png") {
          fileRef = storageRef.child(`images/${file.name}.png`);
        } else {
          fileRef = storageRef.child(`files/${file.name}`);
        }
        await fileRef.put(file);
        const downloadURL = await fileRef.getDownloadURL();
        //Adds the file to the dropzone to be viewed
        this.$refs.imgDropZone.manuallyAddFile(file, downloadURL);
      } catch (error) {
        console.log(error);
      }
    },

    //Shows the lightbox of the files images
    openGallery(index, files) {
      this.media = [];
      for (const file in files) {
        const fi = {
          thumb: files[file].src,
          src: files[file].src,
        };
        this.media.push(fi);
      }
      this.$refs.lightbox.showImage(index);
    },
    openFilePostGallery(media, index) {
      this.media = media;
      this.$refs.lightbox.showImage(index);
    },
    viewReplies(id) {
      this.listReplies = id;
    },
    async setGroupImage(file) {
      var info = {
        group: this.groupId,
        user: this.user,
      };

      var groupType = await this.getGroupType(info);

      const storageRef = firebase.storage().ref();

      if (file["type"] === "image/jpeg" || file["type"] === "image/png") {
        const fileRef = storageRef.child(
          `chatImage/${file.name}${Date.now()}.png`
        );

        await fileRef.put(file); //puts file in firbase storage
        const downloadURL = await fileRef.getDownloadURL(); //gets file url from firebase storage

        this.chatImage = downloadURL; //sets new profile pic
        this.$refs.profileDropZone.removeAllFiles(true); //removes file from dropzone

        await db
          .collection(groupType)
          .doc(this.groupId)
          .update({
            profileImage: downloadURL,
          });
      }
    },

    // if the user clicks reply to a post
    reply(post) {
      this.isReply = true;
      this.replyPost = post;
      this.replyingTo = post.username;
      this.replyingMessage = post.content;
      if (post.content == "" && post.files.length > 0) {
        let attach = post.files.length == 1 ? "Attachment" : "Attachments";
        this.replyingMessage = post.files.length + " " + attach;
      }
      if (this.groupType !== "directMessages") {
        this.post.replyUsername = post.username;
      } else {
        this.post.replyUsername = this.groupName;
      }
      this.post.replyContent = post.content;
      this.post.parent_id = post.id;
    },
    // If replying to a reply
    childReply(post) {
      this.reply(post);
    },
    shouldCreatePost(event) {
      if (this.post.content == "" && this.post.files.length == 0) {
        return false;
      }
      //Check for all spaces
      if (!this.post.content.replace(/\s/g, "").length) {
        this.post.content = "";
        if (this.post.files.length == 0) {
          return false;
        }
      }
      //if shift + enter
      if (event.shiftKey === true && event.key === "Enter") {
        return false;
      }
      return true;
    },
    async onCreatePost(event) {
      if (!this.shouldCreatePost(event)) {
        return;
      }
      if (
        !this.user.course_ids.includes(this.groupId) &&
        !this.user.faculty_ids.includes(this.groupId) &&
        !this.user.group_ids.includes(this.groupId) &&
        !this.user.dm_ids.includes(this.groupId)
      ) {
        return;
      }
      this.$el
        .querySelector("#message")
        .setAttribute("style", "height", `14px`);
      this.post.chat_id = this.groupId;
      this.post.username = this.user.firstName + " " + this.user.lastName;
      this.post.profileImage = this.user.profileImage;
      /*
      if (this.post.replyUsername && this.replyPost) {
        this.post.replyUsername = this.replyPost.username;
        this.post.replyContent = this.replyPost.content;
        if (this.replyPost.files) {
          this.post.replyFiles = this.replyPost.files;
        }
      }*/
      if (this.taggedNames.length > 0) {
        this.taggedNames.forEach((name) => {
          if (!this.post.atRanges) {
            this.post.atRanges = [];
          }
          let index = this.post.content.indexOf(name);
          if (index !== -1) {
            this.post.atRanges.push(index - 1, index - 1 + name.length + 1);
          }
        });
      }
      let postInfo = {
        post: this.post,
        posts: this.recentPosts,
        type: this.groupType,
        id: this.groupId,
        user: this.user,
        groupName: this.groupName,
        curGroup: this.curGroup,
      };
      console.log(postInfo);
      await this.createPost(postInfo);
      if (this.post.replyUsername) {
        this.addReplyToPost();
      }
      this.resetPost();
      this.scroll = true;
      this.showDropArea = false;
      this.fileDropped = false;
    },
    addReplyToPost() {
      db.collection("posts")
        .doc(this.post.parent_id)
        .get()
        .then((doc) => {
          //If the post being replied to is also a reply
          if (doc.data().replyUsername) {
            this.addReply(doc.data().parent_id);
            this.addReply(doc.data().originalPost_id);
          } else {
            this.addReply(doc.data().id);
          }
        });
    },
    resetPost() {
      document.getElementById("message").innerHTML = "";
      this.isReply = false;
      this.taggedNames = [];
      this.post = {
        content: "",
      };
    },
    date(date) {
      var startOfToday = moment().startOf("day");
      var startOfYesterday = startOfToday - 3600000 * 24;
      var startOfDayOneWeekAgo = startOfToday - 3600000 * 24 * 7;
      if (date > startOfToday) {
        return "Today " + moment(date).format("h:mm A");
      } else if (date > startOfYesterday) {
        return "Yesterday " + moment(date).format("h:mm A");
      } else if (date > startOfDayOneWeekAgo) {
        return moment(date).format("dddd h:mm A");
      } else {
        return moment(date).format("ddd, MMM D, h:mm A");
      }
    },
    onDelete(post_id) {
      const name = this.user.firstName + " " + this.user.lastName;
      for (const index in this.posts) {
        if (this.posts[index].id == post_id) {
          this.posts[index].files = [];
          this.posts[index].content = name + " deleted this post";
          this.posts[index].deleted = true;
        }
      }
      this.deletePost({ post_id: post_id, name: name });
    },

    detachListeners() {
      this.listeners.forEach((listener) => listener());
      this.listeners = [];
    },

    checkForUser() {
      if (this.user == null) {
        router.push({
          name: "Login",
        });
      }
    },
  },
};
</script>

<style src="@/styles/views/MessageBoard.css"></style>
